import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex } from 'Components/UI/_Legacy'

export const Container = styled(Flex).attrs({
  ml: [0, 3],
  mr: [3, 0],
  mt: [4, 0],
  px: [3, 5],
  height: [24, 28],
})`
  align-items: center;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 28px;
`

export const IconHolder = styled(Flex)`
  margin-right: 6px;
  width: 12px;
  height: 12px;
  fill: ${themeGet('colors.white')};
  align-items: center;

  > svg {
    width: 100%;
    height: 100%;
  }
`
